<script>
  import { Router, Route } from 'svelte-routing';
  import Navbar from './components/Navbar.svelte';
  import Home from './routes/Home.svelte';
  import AnimeDetail from './routes/AnimeDetail.svelte';
  import Watch from './routes/Watch.svelte';
  import Admin from './routes/Admin.svelte';

  export let url = '';
</script>

<Router {url}>
  <Navbar currentPath={window.location.pathname} />
  
  <Route path="/home" component={Home} />
  <Route path="/anime/:id" let:params>
    <AnimeDetail id={params.id} />
  </Route>
  <Route path="/v/:id" let:params let:location>
    <Watch id={params.id} {location} />
  </Route>
  <Route path="/me" component={Admin} />
  <Route path="/">
    <Home />
  </Route>
</Router>
